export function dateFormat(date, format) {
    const newDate = new Date(date);
    if (format === 'full') {
        return newDate.toLocaleString('en-us', { month: 'long' }) + ' ' + newDate.getDate() + ', ' + newDate.getFullYear();
    }
    if (format === 'short') {
        return newDate.toLocaleString('en-us');
    }
    return newDate;
}
